import {
  type BaseOperatorType, type BaseOptionsType,
} from '@repo/advanced-filters';
import { CriteriaConditionsWrapper } from '@repo/crm-atoms';
import type { FilterLevel } from 'advanced-filters/types/filter';
import { getAdvancedFilterAdditionalKeysSelector } from 'automations/selectors/reactFlow';
import {
  type ReactNode,
} from 'react';
import { useSelector } from 'react-redux';

export interface BuilderUiProps {
  setBuilderOpen: (open: boolean) => void;
  handleDelete: () => void;
  selectedFiltersUi: ReactNode;
  appliedFilters?: {
    levels: FilterLevel[];
    comparator: BaseOperatorType;
  };
}

export default function AutomationsCriteriaConditionsWrapper({
  criteriaId,
  onCriteriaChange,
  builderUi,
  additionalConditionKeys,
  textOnly = false,
  renderFilters = false,
  excludedDefaultKeys = [],
}: {
  criteriaId?: number;
  onCriteriaChange: (savedCriteriaId?: number) => void;
  builderUi: (props: BuilderUiProps) => ReactNode;
  additionalConditionKeys?: BaseOptionsType[];
  textOnly?: boolean;
  renderFilters?: boolean;
  excludedDefaultKeys?: string[];
}) {
  const savedTriggerConditionKeys = useSelector(getAdvancedFilterAdditionalKeysSelector);
  return (
    <CriteriaConditionsWrapper
      criteriaId={criteriaId}
      onCriteriaChange={onCriteriaChange}
      builderUi={builderUi}
      additionalConditionKeys={additionalConditionKeys}
      textOnly={textOnly}
      renderFilters={renderFilters}
      excludedDefaultKeys={excludedDefaultKeys}
      savedTriggerConditionKeys={savedTriggerConditionKeys}
    />
  );
}
